import Vue from 'vue'
import Router from 'vue-router'

import storage from '@/storage'

// import Auth views
import Login from '@imemento/spa-helpers/src/views/auth/Login'
import RecoverPassword from '@imemento/spa-helpers/src/views/auth/RecoverPassword'
import Register from '@imemento/spa-helpers/src/views/auth/Register'
import ResetPassword from '@imemento/spa-helpers/src/views/auth/ResetPassword'
import InsufficientPrivileges from '@imemento/spa-helpers/src/views/auth/InsufficientPrivileges'

import Hotel from "@/views/Hotel";
import Reservation from "@/views/Reservation";
import Confirmation from "@/views/Confirmation";
import Healthy from "@/views/Healthy";
import PageNotFound from "@/views/errors/PageNotFound";
import InternalServerError from "@/views/errors/InternalServerError";
import Home from "@/views/Home";

Vue.use(Router);


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
          path: '/authentication/login',
          component: Login,
          meta: { private_route: false }
        },
        {
          path: '/authentication/recover-password',
          component: RecoverPassword,
          meta: { private_route: false }
        },
        {
          path: '/authentication/register',
          component: Register,
          meta: { private_route: false }
        },
        {
          path: '/authentication/reset-password',
          component: ResetPassword,
          meta: { private_route: false }
        },
        {
          path: '/authentication/insufficient-privileges',
          component: InsufficientPrivileges,
          meta: { private_route: false }
        },
        {
          path: '/healthy',
          component: Healthy,
          meta: { private_route: false }
        },
        {
            path: '/',
            name: 'home',
            component: Home,
             meta: { private_route: true }
        },
        {
            path: '/hotel/:hotelId',
            name: 'hotel',
            component: Hotel,
            
             meta: { private_route: true }
        },
        {
            path: '/reservation',
            name: 'reservation',
            component: Reservation,
            meta: { private_route: true },
            // beforeEnter: (to, from, next) => {
            //     if (sessionStorage.getItem('confirmed') === 'true') {
            //         sessionStorage.clear();
            //         next('/hotel');
            //     }
            //     next();
            // }
        },
        {
            path: '/confirmation',
            name: 'confirmation',
            component: Confirmation,
             meta: { private_route: true },
            // beforeEnter: (to, from, next) => {
            //     if (!sessionStorage.getItem('confirmed')) {
            //         sessionStorage.clear();
            //         next('/hotel');
            //     }
            //     next();
            // }
        },
        
        {
            path: '/404',
            name: '404',
            component: PageNotFound,
             meta: { private_route: true }
        },
        {
            path: '/500',
            name: '500',
            component: InternalServerError,
             meta: { private_route: true }
        }
    ],

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
})

// router before middleware
router.beforeEach(async (to, from, next) => {
    
  if (to.path === '/healthy') {
    return next();
  }

  let token = await storage.getToken();
  let roles = await storage.getRoles();

  if (!token && to.meta.private_route ) {
    localStorage.setItem('path', to.path);
    return next('/authentication/login');
  }

  //to do must be spa_console
  if ((!roles || !roles.ssr_console ||!(roles.ssr_console.includes('admin') || roles.ssr_console.includes('user'))) && to.meta.private_route) {
    return next('/authentication/insufficient-privileges');
  }
  
   return next();
});

export default router;
